import React from "react";
import Textsilider from "./Textsilider";
import "./Wininfo.css";
const Wininfo = () => {
  return (
    <>
      <div className="top-winersinfo">
        <Textsilider/>
      </div>
    </>
  );
};

export default Wininfo;
